/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:12:04
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2021-04-25 22:19:10
 */

// 404
const notFind = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/notFind/notFind.vue'))
  }, 'notFind')
}

// 首页
const index = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/index/index.vue'))
  }, 'index')
}

// 文章
const article = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/article/index.vue'))
  }, 'article')
}

// 活动
const activity = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/activity/index.vue'))
  }, 'activity')
}

// 活动详情
const activityDetails = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/activityDetails/index.vue'))
  }, 'activityDetails')
}

// 支付
const pay = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/pay/index.vue'))
  }, 'pay')
}

export default {
  notFind,
  index,
  article,
  activity,
  activityDetails,
  pay
}



// WEBPACK FOOTER //
// ./src/router/fileLoad.js